<template>
  <div class="gFolder">
    <div class="info">
      <img :src="gFile.iconLink" class="icon">
      <bread-crumbs :gFolder="gFile" :maxAge="15000" />
    </div>
    <div class="description">
      created on {{ gFile.createdTime | moment("dddd, MMMM Do YYYY, h:mm:ss a") }} -
      owned by
      <span v-for="(owner, index) in gFile.owners" :key="index" class="owner">
        <template v-if="index > 0">, </template>{{ owner.displayName }}
      </span>
      <span v-if="gFile.driveId" class="owner">
        Team Drive "{{ driveName }}"
      </span>
      <a href="#" title="show raw data" @click.prevent.stop="showJson=!showJson">*</a>
      <br />
      {{gFile.description}}
      <pre v-if="showJson">{{ gFile }}</pre>
    </div>
    <button class="btn show btn-sm btn-outline-primary" @click.prevent.stop="onShow">Show</button>
    <favorite :gFolder="gFile" />
  </div>
</template>

<script>
import { GApiMixin } from '@/mixins/GApiMixin.js'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import Favorite from '@/components/Favorite.vue'
export default {
  name: 'GFileResultItem',
  mixins: [GApiMixin],
  props: {
    gFile: Object
  },
  components: {
    BreadCrumbs,
    Favorite
  },
  data () {
    return {
      breadcrumbs: [],
      loading: false,
      showJson: false,
      driveName: ''
    }
  },
  mounted () {
    if (this.gFile.driveId) {
      this.getFile(this.gFile.driveId).then(drive => {
        this.driveName = drive.name
      })
    }
  },
  computed: {
    isFavorite () {
      return this.$store.getters.existInFavorite(this.gFile.id)
    }
  },
  methods: {
    onShow () {
      // this.gRootFolderId = this.gFile.id
      this.$router.push({ name: 'Review', params: { id: this.gFile.id } })
      // router.push({ path: `/user/${userId}` }) // -> /user/123
    }

  }
}
</script>
